import { h } from 'preact';
import cx from 'classnames';
import style from './style';

export default function WidthConstrain({ showWideView, children, class: cls, ...props }) {
	return <div class={cx(showWideView && style.wideWithConstrain, style.widthConstrain, cls)} {...props}>{children}</div>;
}
